import { Controller } from "@hotwired/stimulus";
import geolocation from "/libs/geolocation";
import Toast from "/libs/toast";
import { i18n } from "/locales/i18n";

class GeolocationController extends Controller {
  static AVAILABLE = 1;
  static UNAVAILABLE = 2;
  static DENIED = 3;
  static targets = ["geolocation", "city", "error", "citySearch", "radius"];
  static values = {
    radius: { type: Number, default: 70 },
  };

  positionStatus = GeolocationController.UNAVAILABLE;
  #boundPositionUpdated;
  #boundPositionDenied;
  #boundPositionUnavailable;

  initialize() {
    this.#boundPositionUpdated = this.#positionUpdated.bind(this);
    this.#boundPositionDenied = this.#positionDenied.bind(this);
    this.#boundPositionUnavailable = this.#positionUnavailable.bind(this);
  }

  connect() {
    document.addEventListener("position:updated", this.#boundPositionUpdated);
    document.addEventListener("position:denied", this.#boundPositionDenied);
    document.addEventListener(
      "position:unavailable",
      this.#boundPositionUnavailable,
    );

    if (geolocation.isAvailable())
      this.#updateStatus(GeolocationController.AVAILABLE);
    else this.startGeolocation();
  }

  disconnect() {
    document.removeEventListener(
      "position:updated",
      this.#boundPositionUpdated,
    );
    document.removeEventListener("position:denied", this.#boundPositionDenied);
    document.removeEventListener(
      "position:unavailable",
      this.#boundPositionUnavailable,
    );
  }

  geolocationMode() {
    this.geolocationTarget.querySelector('input[type="radio"]').checked = true;
    this.citySearchTarget.toggleAttribute("hidden", true);
    this.#resetRadius();
    if (this.positionStatus == GeolocationController.DENIED)
      this.startGeolocation();
  }

  cityMode(reset = true) {
    this.cityTarget.querySelector('input[type="radio"]').checked = true;
    this.citySearchTarget.removeAttribute("hidden");
    if (reset) this.#resetRadius();
  }

  startGeolocation() {
    this.geolocationTarget.toggleAttribute("progress", true);
    geolocation.start();
  }

  #resetRadius() {
    this.radiusTarget.dispatchEvent(
      new CustomEvent("update-radius", {
        detail: { radius: this.radiusValue },
      }),
    );
  }

  #updateStatus(status) {
    this.positionStatus = status;
    this.geolocationTarget.removeAttribute("progress");

    if (this.positionStatus == GeolocationController.AVAILABLE) {
      this.errorTarget.toggleAttribute("hidden", true);
      this.geolocationTarget.removeAttribute("unavailable");
    } else {
      //this.errorTarget.textContent = i18n.t(`js.geolocation.error.${this.positionStatus == GeolocationController.UNAVAILABLE ? 'unavailable' : 'denied'}`)
      this.errorTarget.removeAttribute("hidden");
      //new Toast(i18n.t('js.geolocation.error.toast', 'alert')).show()
      this.geolocationTarget.toggleAttribute("unavailable", true);
      this.cityMode(false);
    }
  }

  #positionUpdated(event) {
    this.#updateStatus(GeolocationController.AVAILABLE);
  }

  #positionUnavailable(event) {
    this.#updateStatus(GeolocationController.UNAVAILABLE);
  }

  #positionDenied(event) {
    this.#updateStatus(GeolocationController.DENIED);
  }
}

export default GeolocationController;
